module.exports = __webpack_public_path__ + "static/media/outletslider.060ce7d2.jpg";